// Maps string icon names (from data.js) to lucide-react components.
import {
  Coffee, Flower2, Notebook, ScrollText, Gem, Flame, FolderOpen, Disc3,
  MessageCircle, KeyRound, Globe, Gift, Sparkles, Heart, Gamepad2, Crown,
} from "lucide-react";

export const ICONS = {
  Coffee, Flower2, Notebook, ScrollText, Gem, Flame, FolderOpen, Disc3,
  MessageCircle, KeyRound, Globe, Gift, Sparkles, Heart, Gamepad2, Crown,
};

export function Icon({ name, ...props }) {
  const Cmp = ICONS[name] || Sparkles;
  return <Cmp {...props} />;
}
